<template>
  <div class="ex-list">
    <ticketItem v-for="(item) in datas" :data="item" :key="item.dataId" @onClick="onClick"></ticketItem>
    <el-dialog :visible.sync="dialogVisible" width="400px">
      <div class="login-box">
        <Login></Login>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ticketItem from './ticketItem'
import Login from '../member/login'

export default {
  name: 'ExhibitionList',
  props: { datas: Array },
  components: { ticketItem, Login },
  data() {
    return { dialogVisible: false }
  },
  methods: {
    onClick(event) {
      // 未登录
      if (!localStorage.token) {
        this.dialogVisible = true
        event.preventDefault()
      }
    }
  }
}
</script>
<style scoped>
.ex-list {
  margin-right: -21px;
  overflow: hidden;
}
</style>
